import { Mediator } from '@spotahome/soyuz-mediator';
import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import { CHANNELS } from '../utils/constants';

import { DSIcon } from '../../../base';

import AgeRange from './rules/AgeRange';
import BookingEarly from './rules/BookingEarly';
import CouplesNotAllowed from './rules/CouplesNotAllowed';
import MinStay from './rules/MinStay';
import Gender from './rules/Gender';

import styles from './InstantBookingModal.module.scss';

const RULES = [
  'ageRange',
  'gender',
  'couplesNotAllowed',
  'bookingTooEarly',
  'minStay'
];

const rulesCorrelation = {
  ageRange: props => <AgeRange {...props} />,
  bookingTooEarly: props => <BookingEarly {...props} />,
  minStay: props => <MinStay {...props} />,
  couplesNotAllowed: () => <CouplesNotAllowed />,
  gender: props => <Gender {...props} />
};

const VariantLabel = () => (
  <span className={styles['instant-modal__header-label-with-icon']}>
    <DSIcon name="electricity_bill" size="l" />
    {trans('property_show.book_now_card.instant_booking')}
  </span>
);

const Rules = ({ rules }) => (
  <ul className={styles['instant-modal__rules-list']}>
    {RULES.map(ruleType => {
      const rule = rules.find(r => r.type === ruleType) || {};
      const RuleComponent = rulesCorrelation[rule.type];

      return RuleComponent ? (
        <RuleComponent key={ruleType} {...rule.params} />
      ) : null;
    })}
  </ul>
);

const OriginalBody = ({ rules }) => (
  <>
    <p
      className={styles['instant-modal__text-title instant-modal__text-block']}
    >
      {trans('property_show.instant_booking_modal.title')}
    </p>
    <p className={styles['instant-modal__text-block']}>
      {trans('property_show.instant_booking_modal.description.1')}
    </p>
    <p className={styles['instant-modal__text-block']}>
      {trans('property_show.instant_booking_modal.description.2')}
    </p>
    <Rules rules={rules} />
    <p
      className={styles['instant-modal__text-block']}
      dangerouslySetInnerHTML={{
        __html: trans('property_show.instant_booking_modal.check_rules')
      }}
    />
    <p className={styles['instant-modal__text-block']}>
      {trans('property_show.instant_booking_modal.dont_worry')}
    </p>
  </>
);

const VariantBody = ({ rules }) => (
  <>
    <p
      className={styles['instant-modal__text-title instant-modal__text-block']}
    >
      {trans('property_show.instant_booking_modal.description.variant')}
    </p>
    <div>
      <h5 className={styles['instant-modal__title-block']}>
        {trans('property_show.instant_booking_modal.criteria.title')}
      </h5>
      <Rules rules={rules} />
    </div>
    <div>
      <h5 className={styles['instant-modal__title-block']}>
        {trans('property_show.instant_booking_modal.what-if.title')}
      </h5>
      <p className={styles['instant-modal__text-block']}>
        {trans('property_show.instant_booking_modal.what-if.description')}
      </p>
    </div>
  </>
);

const InstantBookingModalTitle = () => {
  const isVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  return isVariant ? (
    <VariantLabel />
  ) : (
    trans('property_show.instant_booking_modal.header')
  );
};

const InstantBookingModalContent = ({ rules }) => {
  const isVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  return isVariant ? (
    <VariantBody rules={rules} />
  ) : (
    <OriginalBody rules={rules} />
  );
};

const openInstantBookingModal = ({ rules = [] } = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: <InstantBookingModalTitle />,
    body: <InstantBookingModalContent rules={rules} />,
    fullscreenOnMobile: true
  });
};

export default openInstantBookingModal;
